import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import 'components/styles/search-records.css';
import CustomInput from 'components/custom-input';
import Cookies from 'universal-cookie';
import { PARTNERSHIP_URL } from '../constants/index';
import { ReactComponent as SearchIcon } from 'assets/images/search-icon.svg';

const SearchRecords = ({ setEmployeeData, showDeleteSuccessMessage, showDelinkSuccessMessage }) => {
  const [searchEmployeeID, setSearchEmployeeID] = useState('');
  const [searchEmployeeIDError, setSearchEmployeeIDError] = useState('');

  const cookies = new Cookies();

  const isEmployeeIDValid = () => {
    if (!searchEmployeeID) {
      setSearchEmployeeIDError('Please enter Employee ID');
      return false;
    }
    setSearchEmployeeIDError('');
    return true;
  };

  const searchEmployeeRecordByID = async () => {
    if (isEmployeeIDValid()) {
      try {
        const token = cookies.get('token');
        const response = await axios.get(
          `${PARTNERSHIP_URL}/employees/${searchEmployeeID}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );
        if (response.data) {
          setEmployeeData(response.data.data);
        } else {
          setEmployeeData(null);
        }
      } catch (error) {
        setEmployeeData(null);
        setSearchEmployeeIDError('Employee does not exist');
      }
    }
  };

  useEffect(() => {
    if (!showDeleteSuccessMessage && !showDelinkSuccessMessage) {
      setSearchEmployeeID('');
    }
  }, [showDeleteSuccessMessage, showDelinkSuccessMessage]);

  return (
    <div className="search-records-box">
      <div className="search-header">Update an employee&apos;s record</div>
      <div className="search-bar">
        <CustomInput
          type="text"
          label="Search by Employee ID"
          value={searchEmployeeID}
          error={searchEmployeeIDError}
          onChange={setSearchEmployeeID}
          className={searchEmployeeIDError ? 'error' : ''}
        />
        <button onClick={searchEmployeeRecordByID} className="search-icon">
          <SearchIcon/>
        </button>
      </div>
    </div>
  );
};

SearchRecords.propTypes = {
  setEmployeeData: PropTypes.func,
  showDeleteSuccessMessage: PropTypes.bool,
  showDelinkSuccessMessage: PropTypes.bool
};

export default SearchRecords;
